class EpicplyCategoryHero extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    const track = this.querySelector('.epicply-hero__track');
    const panels = [...this.querySelectorAll('.epicply-hero__panel')];
    const pagination = this.querySelector('.epicply-hero__pagination');
    const buttons = [...this.querySelectorAll('.epicply-hero__dot')];
    if (!track || !panels.length) return;

    // Native scrolling remains the fallback; only enhance the optional indicators.
    const reveal = (panel) => {
      const distance = panel.getBoundingClientRect().left - track.getBoundingClientRect().left - 16;
      track.scrollBy({ left: distance, behavior: 'instant' });
    };
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => reveal(panels[index]), { signal });
    });
    if (pagination) {
      pagination.hidden = false;
      const update = () => {
        const start = track.getBoundingClientRect().left + 16;
        let closest = 0;
        panels.forEach((panel, index) => {
          if (Math.abs(panel.getBoundingClientRect().left - start) < Math.abs(panels[closest].getBoundingClientRect().left - start)) closest = index;
        });
        buttons.forEach((button, index) => {
          if (index === closest) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
      };
      const schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(update);
      };
      track.addEventListener('scroll', schedule, { passive: true, signal });
      this.observer = new ResizeObserver(schedule);
      this.observer.observe(track);
      update();
    }
    this.addEventListener('shopify:block:select', (event) => {
      const panel = panels.find((item) => item.dataset.blockId === event.detail.blockId);
      panels.forEach((item) => item.removeAttribute('data-selected'));
      if (!panel) return;
      panel.setAttribute('data-selected', '');
      if (getComputedStyle(track).flexDirection === 'column') {
        panel.scrollIntoView({ block: 'nearest', behavior: 'instant' });
      } else if (track.scrollWidth > track.clientWidth) {
        reveal(panel);
      }
    }, { signal });
    this.addEventListener('shopify:block:deselect', () => {
      panels.forEach((panel) => panel.removeAttribute('data-selected'));
    }, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    cancelAnimationFrame(this.frame);
  }
}

if (!customElements.get('epicply-category-hero')) {
  customElements.define('epicply-category-hero', EpicplyCategoryHero);
}
